import { Injectable } from '@angular/core';
import { SearchCriterionsDataType } from '../services/client-side-search.service';
import { Criterion } from '../services/base-event-service';

@Injectable({
  providedIn: 'root',
})
export class WorkspacesSearchCriterionsFactory {
  constructor() {}
  protected readonly entities = {
    [WORKSPACES_SEARCH_CRITERION.NAME]: {
      id: WORKSPACES_SEARCH_CRITERION.NAME,
      title: 'Workspace Name',
      data: ['name'],
      type: SearchCriterionsDataType.String,
      controlName: 'workspaceName',
    },
  };

  getAllItemsAsArray() {
    return Object.values(this.entities) as Criterion[];
  }

  getById(id: number | WORKSPACES_SEARCH_CRITERION) {
    const item = { ...this.entities[id as WORKSPACES_SEARCH_CRITERION] };
    if (!item) {
      throw new Error(`Unknown id ${id} in ${this.constructor.name}`);
    }
    return item;
  }
}

export enum WORKSPACES_SEARCH_CRITERION {
  NAME = 1,
}
